/**
 * Various utility functions related to time.
 */

export function sleep(ms) {
    return new Promise((r) => setTimeout(r, ms));
}
